var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMusicOn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7621_27018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.107 0.263143C14.8966 0.222185 14.6796 0.230005 14.4727 0.286001H14.4659L5.74246 2.70772C5.44677 2.78813 5.18556 2.96318 4.99877 3.2061C4.81199 3.44902 4.70992 3.74643 4.70817 4.05286V10.3317C4.14871 10.0916 3.52674 10.0382 2.93454 10.1795C2.34235 10.3208 1.81149 10.6493 1.42074 11.1162C1.02999 11.583 0.800162 12.1635 0.76537 12.7713C0.730578 13.3791 0.89267 13.982 1.2276 14.4904C1.56252 14.9988 2.05243 15.3857 2.62463 15.5937C3.19684 15.8016 3.82084 15.8196 4.40405 15.6448C4.98726 15.4701 5.49859 15.112 5.86219 14.6237C6.22578 14.1354 6.42226 13.5428 6.42246 12.934V6.94429L14.5253 4.69286V7.50886C13.9688 7.27027 13.3505 7.2164 12.7612 7.35513C12.1718 7.49387 11.6425 7.81791 11.2508 8.27968C10.8592 8.74145 10.626 9.31661 10.5853 9.92071C10.5447 10.5248 10.6988 11.126 11.0251 11.6361C11.3514 12.1461 11.8326 12.5381 12.398 12.7545C12.9635 12.9709 13.5835 13.0003 14.1669 12.8384C14.7503 12.6765 15.2664 12.3318 15.6395 11.8549C16.0125 11.378 16.2229 10.7941 16.2396 10.1889V1.60257C16.2315 1.28391 16.115 0.97753 15.9093 0.734014C15.7036 0.490498 15.4199 0.324402 15.107 0.263143Z",
    fill: "#00BFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7621_27018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMusicOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_music_on.99c24c71d7534ee2d32e95be3cfd52f6.svg";